export enum OperandType {
    CONDITION = 'CONDITION',
    VALUE = 'VALUE',
}
